import Button from '../button';
import Spinner from '../spinner';
import styles from './style.module.css';


interface Props {
  handleClick: () => void;
  title: string;
  subtitle: string;
  buttonLabel: string;
  loading?: boolean;
  secondaryButtonLabel?: string;
  onSecondaryClick?: () => void;
}

const SimpleFrame = (props: Props) => {
  const {
    title,
    subtitle,
    buttonLabel,
    loading,
    handleClick,
    secondaryButtonLabel,
    onSecondaryClick,
  } = props;

  const showSecondary = Boolean(secondaryButtonLabel && onSecondaryClick);

  return (
      <div className={`content ${styles.container}`}>
        <div className={styles.stick}>
          <div className={styles.text}>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          {loading ? (
            <div className={styles.spinner}><Spinner/></div>
          ) : (
            <div className={styles.actions}>
              <Button label={buttonLabel} onClick={() => handleClick()} />
              {showSecondary && (
                <Button
                  label={secondaryButtonLabel!}
                  variant="secondary"
                  onClick={() => onSecondaryClick!()}
                />
              )}
            </div>
          )}
        </div>
      </div>
  )
}

export default SimpleFrame;